
import { types as itemTypes } from '~/utils/product-item-type'

import bottlePlaceholderImg from '~/assets/images/bottle-placeholder.svg'
import caskPlaceholderImg from '~/assets/images/cask-placeholder.svg'
import basketPlaceholderImg from '~/assets/images/basket-placeholder.png'

export default {
  props: {
    slug: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
    valueLabel: {
      type: String,
      default: null,
    },
    secondaryValue: {
      type: Number,
      default: null,
    },
    secondaryLabel: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      required: false,
      default: undefined,
    },
    batchName: {
      type: String,
      required: false,
      default: undefined,
    },
    id: {
      type: Number,
      required: true,
    },
    showBuyButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    type: {
      type: String,
      default: itemTypes.Bottle,
    },
  },

  computed: {
    productUrl() {
      return this.$isBasket({ itemType: this.type })
        ? `/whisky/basket/${this.slug}`
        : `/whisky/${this.slug}`
    },

    imageAlt() {
      return `${this.$gettext('Product image for:')} ${this.title}`
    },

    imageSrc() {
      if (this.image) {
        // Add Imgix params to improve size of images. See https://www.datocms.com/docs/general-concepts/images
        return `${this.image}?w=260&fm=webp&fit=crop&auto=format`
      }

      return this.placeholderImageSrc
    },

    placeholderImageSrc() {
      if (this.type === itemTypes.Basket) {
        return basketPlaceholderImg
      }

      if (this.type === itemTypes.Cask) {
        return caskPlaceholderImg
      }

      return bottlePlaceholderImg
    },
  },

  methods: {
    onBuyClicked(e) {
      e.preventDefault()

      this.$emit('buy', this.id)
    },
    getChipClass(chipText) {
      return chipText.length > 40
        ? 'whisky-catalogue-list-view-chip-text-wrap'
        : ''
    },
  },
}
